export default (state, action) => {
    switch(action.type) {
        case 'GET_PRODUCTS':
            return {
                ...state,
                products: action.payload,
                loading: false
            };
        case 'ADD_PRODUCT':
            return {
                ...state,
                products: [action.payload, ...state.products],
                loading: false
            };
        case 'DELETE_PRODUCT':
            return {
                ...state,
                products: state.products.filter(product => product.product_id !== action.payload),
                loading: false
            };
        case 'UPDATE_PRODUCT':
            return {
                ...state,
                products: state.products.map(product => 
                    product.product_id === action.payload.product_id ? { ...product, ...action.payload } : product
                ),
                loading: false
            };
        case 'PRODUCT_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}
